import { userLockConstants } from '../constants/userlock.constants';
import userLockService from '../services/userlock.service';
import { alertActions } from './alert.actions';
import { b64toBlob } from '../helpers/base64';

export const userLockActions = {
  fetch
};

function fetch(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const userLockRegisters = await userLockService.fetch(params);  
      if (params.exportPdf && userLockRegisters.file) {        
        const blob = b64toBlob(userLockRegisters.file, {type: 'application/pdf'});
        var csvURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', 'acessos.pdf');
        tempLink.click();
      } else if (params.export && userLockRegisters.file) {        
        const blob = b64toBlob(userLockRegisters.file, {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        var csvURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', 'acessos.xlsx');
        tempLink.click();
      }
           
      dispatch(success(userLockRegisters));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: userLockConstants.FETCH_REQUEST } }
  function success(notifications) { return { type: userLockConstants.FETCH_SUCCESS, notifications } }
  function failure(error) { return { type: userLockConstants.FETCH_FAILURE, error } }
}

